import scraperStyles from '@/pages/ScraperPage.module.css';

export function ScraperStatusBadge({ status }: { status: string }) {
  const s = status.toLowerCase();
  let extra = '';
  if (s === 'running') extra = scraperStyles.statusRunning;
  else if (s === 'completed') extra = scraperStyles.statusCompleted;
  else if (s === 'failed') extra = scraperStyles.statusFailed;
  else if (s === 'queued') extra = scraperStyles.statusQueued;

  return (
    <span className={`${scraperStyles.statusBadge} ${extra}`.trim()}>{status}</span>
  );
}
